import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AreaTabs } from '@/features/nav/AreaTabs';

export const Route = createFileRoute('/_authenticated/archive')({
  component: () => (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl">Lưu trữ</h1>
      <AreaTabs areaId="archive" />
      <Outlet />
    </div>
  ),
});
